import { render, staticRenderFns } from "./OfficerOpenRecruitmentPostEdit.vue?vue&type=template&id=774a8e9c&scoped=true&"
import script from "./OfficerOpenRecruitmentPostEdit.vue?vue&type=script&lang=js&"
export * from "./OfficerOpenRecruitmentPostEdit.vue?vue&type=script&lang=js&"
import style0 from "./OfficerOpenRecruitmentPostEdit.vue?vue&type=style&index=0&id=774a8e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774a8e9c",
  null
  
)

export default component.exports